function debounce<F extends (...args: never[]) => void>(
  func: F,
  wait: number,
): (...funcArgs: Parameters<F>) => void {
  let timeout: NodeJS.Timeout | null = null;

  return (...args: Parameters<F>): void => {
    if (timeout) {
      clearTimeout(timeout);
    }

    if (wait === 0) {
      func(...args);
    } else {
      timeout = setTimeout(() => {
        func(...args);
        timeout = null;
      }, wait);
    }
  };
}

export default debounce;
